<template>
  <q-img fit="contain" :height="height" :width="width" :src="image_url" @error="set_fallback_url"></q-img>
</template>

<script>
import { computed, ref } from "vue";
import Utilities from "src/composables/Utilities";

export default {
  name: "PlanBrandImage",
  props: {
    plan: {
      type: Object
    },
    width: {
      type: String
    },
    height: {
      type: String
    }
  },
  setup(props) {
    const { plan_brand_image_name } = Utilities();

    const svg_image_url = computed(() => {
      return `${process.env.ASSETS_URL}images/${plan_brand_image_name(props.plan)}.svg`
    })
    const alt_image_url = computed(() => {
      return `${process.env.ASSETS_URL}images/${plan_brand_image_name(props.plan)}.png`
    })

    const use_fallback = ref(false);
    const set_fallback_url = function () {
      use_fallback.value = true
    }

    const image_url = computed(() => {
      if (use_fallback.value) {
        return alt_image_url.value;
      }
      else {
        return svg_image_url.value || alt_image_url.value
      }
    });

    return {
      image_url,
      set_fallback_url
    }
  }
}
</script>

<style scoped>

</style>